/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON, FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON, } from './FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier(value) {
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Type': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON(json['Type']),
        'Id': json['Id'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Type': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON(value['Type']),
        'Id': value['Id'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier.js.map